import React from 'react';
import { Layout } from 'antd';
import styled from 'styled-components';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import { Outlet } from 'react-router-dom';
import { COLORS } from '../../utils/constants';

const { Content } = Layout;

const AppLayout: React.FC = () => {
  return (
    <StyledRootLayout>
      <Sidebar />
      <StyledMainLayout>
        <Navbar />
        <StyledContent>
          <Outlet />
        </StyledContent>
      </StyledMainLayout>
    </StyledRootLayout>
  );
};

const StyledRootLayout = styled(Layout)`
  min-height: 100vh;
`;

const StyledMainLayout = styled(Layout)`
  display: flex;
  height: 100vh;
  margin-left: 256px;
`;

const StyledContent = styled(Content)`
  padding: 37px;
  padding-top: 21px;
  background: ${COLORS.white.primary};
  min-height: 280px;
  margin-top: 72px;
  overflow-y: auto;
  flex-grow: 1;
`;

export default AppLayout;
